import React from 'react';
import styles from './styles.module.scss';
import packageJson from '../../../package.json';

export const NonProductionNotice: React.FC = () => {
  if (process.env.APP_ENV === 'production') return null;

  return (
    <span className={styles.stagingNotice}>
      {`${process.env.APP_ENV}`.toLowerCase()}
      {' '}
      - v
      {packageJson.version}
    </span>
  );
};
